/* Bhairav Tatva v3 — watch-video button, copy stone ID, gemstone tile toggle. Loads after bt.js. */
(() => {
  // Mark the gallery when the video slide is showing, so the "Watch video" button can step aside.
  const Gal = customElements.get('bt-gallery');
  if (Gal && !Gal.prototype.__btV3) {
    const orig = Gal.prototype.setActive;
    Gal.prototype.setActive = function (n) {
      orig.call(this, n);
      const s = this.slides && this.slides[this.i];
      this.toggleAttribute('data-on-video', !!(s && s.dataset.vimeo));
    };
    Gal.prototype.__btV3 = true;
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest ? e.target : null;
    if (!t) return;

    const vid = t.closest('.bt-gcard__vid');
    if (vid && window.btCards) {
      e.preventDefault();
      e.stopPropagation();
      const m = vid.closest('.bt-gcard__media');
      if (window.btCards.current() === m && m.hasAttribute('data-pinned')) {
        window.btCards.stop();
        m.removeAttribute('data-pinned');
      } else {
        document.querySelectorAll('.bt-gcard__media[data-pinned]').forEach((x) => x.removeAttribute('data-pinned'));
        window.btCards.play(m);
        m.setAttribute('data-pinned', '');
      }
      return;
    }

    const watch = t.closest('[data-bt-watch]');
    if (watch) {
      const g = watch.closest('bt-gallery');
      if (g && g.go) g.go(Number(watch.dataset.btWatch));
      return;
    }

    const copy = t.closest('[data-bt-copy]');
    if (copy) {
      const label = copy.querySelector('[data-bt-copy-label]');
      const done = () => {
        copy.classList.add('is-done');
        if (label) label.textContent = 'Copied';
        setTimeout(() => { copy.classList.remove('is-done'); if (label) label.textContent = 'Copy'; }, 1600);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.btCopy).then(done, done);
      else done();
      return;
    }

    const tog = t.closest('[data-gcats-toggle]');
    if (tog) {
      const list = tog.previousElementSibling;
      if (!list) return;
      const open = list.classList.toggle('is-open');
      tog.setAttribute('aria-expanded', open ? 'true' : 'false');
      tog.querySelector('[data-gcats-more]').hidden = open;
      tog.querySelector('[data-gcats-less]').hidden = !open;
    }
  });

  // A video started with the button keeps playing when the pointer leaves the card.
  window.addEventListener('pointerout', (e) => {
    const m = e.target.closest && e.target.closest('.bt-gcard__media[data-pinned]');
    if (m && !m.contains(e.relatedTarget)) e.stopPropagation();
  }, true);
  // Clear the pinned flag when another card takes over.
  new MutationObserver((list) => list.forEach((r) => {
    if (r.target.matches('.bt-gcard__media[data-pinned]') && !r.target.classList.contains('is-playing')) r.target.removeAttribute('data-pinned');
  })).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });

  // Hide the toggle when there are 8 tiles or fewer.
  const tidy = () => document.querySelectorAll('[data-gcats-toggle]').forEach((b) => {
    const list = b.previousElementSibling;
    if (list && list.children.length <= 8) b.hidden = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidy);
  else tidy();
})();
